import RaQFullForm from '@modules/requestAQuote/RaQFullForm'
import { RaQFormType, RaQPageType } from 'pages/things-to-do/[...slug]'
import React from 'react'

interface IDetailsPageSectionsWrapper {
  data?: any
  children: React.ReactNode
  topNavigation: any
  raqFormType?: RaQFormType
  pageType: RaQPageType
  lessTopPadding?: boolean
}

const DetailsPageSectionsWrapper = ({
  data,
  children,
  topNavigation,
  raqFormType,
  pageType,
  lessTopPadding,
}: IDetailsPageSectionsWrapper): JSX.Element => {
  return (
    <div
      className={`flex flex-col justify-space-between h-full w-full max-w-[1376px] mx-auto mt-4 desktop:mt-0 desktop:flex-row 
      ${lessTopPadding ? 'desktop:pt-4' : 'desktop:pt-12'} desktop:gap-[16px]`}
    >
      <div className={`relative flex flex-col w-full desktop:min-w-[59.44%]`}>
        {/* LocationInfo */}
        {children}
      </div>
      {/* REVIEWS END */}
      {raqFormType && (
        <RaQFullForm
          topNavigation={topNavigation}
          raqFormType={raqFormType}
          data={data}
          raqPageType={pageType}
        />
      )}
    </div>
  )
}

export default DetailsPageSectionsWrapper
